import { cn } from '@rocco/utils/cn';

export interface CategoryPillItem {
    id: number;
    title: string;
    link: string;
    itemsCount: number;
}

interface CategoryPillsProps {
    categories: CategoryPillItem[];
    selectedCategory: CategoryPillItem | null;
    onSelectCategory: (category: CategoryPillItem) => void;
}

/**
 * Shared pill-shaped category buttons used by EditorsChoice section.
 * These don't navigate - they filter products inline.
 */
export const CategoryPills = ({
    categories,
    selectedCategory,
    onSelectCategory,
}: CategoryPillsProps) => {
    if (!categories.length) {
        return null;
    }

    return (
        <div
            className="scrollbar-hide flex items-center gap-3 overflow-x-auto"
            role="tablist"
            aria-label="Category filters"
        >
            {categories.map((category) => {
                const isActive = selectedCategory?.id === category.id;
                return (
                    <button
                        key={category.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        onClick={() => onSelectCategory(category)}
                        className={cn(
                            'px-5.25 flex h-10.5 shrink-0 items-center justify-center rounded-full text-base tracking-[-0.05rem] transition-colors',
                            isActive
                                ? 'bg-[#171616] text-white'
                                : 'bg-[#f2f2f2] text-[#323232] hover:bg-gray-200',
                        )}
                    >
                        {category.title}
                    </button>
                );
            })}
        </div>
    );
};
